(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('AuditLogService', AuditLogService);

    AuditLogService.$inject = ['$resource'];

    function AuditLogService($resource) {
        var service = $resource('api/audit-log/:id', {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            },
            'loadByAction': {
                url: 'api/audit-log/actions',
                method: 'GET',
                isArray: true,
                params: {action: null}
            }
        });
        return service;
    }
})();
